module.exports = __webpack_public_path__ + "img/c01_unittechsarissophoroichampion_Normal_ua.9c840577.webp";